import script from "./IntroSplash.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroSplash.vue?vue&type=script&setup=true&lang=js"

import "./IntroSplash.vue?vue&type=style&index=0&id=21428838&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21428838"]])

export default __exports__